import { parseLoadQuoteCapacity } from "../../load-quote";
import { getQuoteFormLcvSliderCapacityRange } from "./fields/QuoteFormLcvCapacitySlider";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export function getQuoteFormCapacityError(
    tonnes: string | undefined,
    isRemoteConfigLoaded: boolean,
    t: TranslateFn
): string | undefined {
    const trimmed = tonnes?.trim() ?? "";

    if (!trimmed) {
        return t("homepageV2:hero.quoteForm.capacityRequired");
    }

    const capacity = parseLoadQuoteCapacity(trimmed);
    if (capacity == null) {
        return t("homepageV2:hero.quoteForm.capacityInvalid");
    }

    if (!isRemoteConfigLoaded) {
        return undefined;
    }

    const { min, max, capacityText } = getQuoteFormLcvSliderCapacityRange();
    if (capacity < min || capacity > max) {
        return t("homepageV2:hero.quoteForm.capacityOutOfRange", { range: capacityText });
    }

    return undefined;
}
